/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import Button from '@mui/material/Button';
import UIGrid from '../uigrid';
import Notification from '../../shared/notification-modal';
import { defaultModalOptions } from '../../shared/constantVariable';
// import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'; // Optional theme CSS

const RoTable = (props) => {
  const { colDefArr, option, rowData, handleAfterBlur, handleClick, onValueChange, translateObject } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  let roStageRowsNumber = 5; // no. of rows to show of at instlization
  // no .of stage data rows
  const [roStageRows, setROStageRows] = useState(roStageRowsNumber);
  // when ever click on add new rows it will increase no of rows in stage data
  const roaddrows = () => {
    setROStageRows(roStageRows < 9 ? roStageRows + 1 : roStageRows);
  };
  // Attach an 'input' event listener to all text input fields
  $('input[type=text]').on('input', (event) => {

    // Check if the input value starts with '0' and has more than one character
    if (event.target.value.startsWith('0') && event.target.value.length > 1) {

      // Replace leading zeros with nothing and convert the result to a number
      // This will remove leading zeros as the user types
      event.target.value = Number(event.target.value.replace(/^0+/, ''));
    }
  });
  // no of row to hide and show in ui
  // when ever we increment value in rostagerows
  useEffect(() => {
    for (let i = roStageRows; i < 9; i += 1) {
      $(`.ro-table_container .row_${i}`).hide();
    };
    for (let i = 1; i < roStageRows; i += 1) {
      $(`.ro-table_container .row_${i}`).show();
    };
  }, [roStageRows]);
  // if stage data has lessthan 4 rows of data we are showing remaing value as empty
  // when ever stage data is updates we are updating rostagerows numbers
  useEffect(() => {
    const rowData1 = rowData.filter((d) => Number(d.pressureVessels) !== 0);
    roStageRowsNumber = rowData1.length < 5 ? 2 :  2;
    setROStageRows(roStageRowsNumber);
  }, [rowData]);
  useEffect(() => {
    $('.ro-table_container .row_1 input').attr('disabled', null);
    $('.ro-table_container .row_1 select').attr('disabled', null);
    $('.ro-table_container #input_num1_1').attr('disabled', true);
    $('.ro-table_container #input_num1_12').attr('disabled', true);
    $('.ro-table_container #input_num1_13').attr('disabled', true);
    $('.ro-table_container #input_num1_14').attr('disabled', true);
  }, []);
  return (
    <div>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <div className="ro-table_container ag-theme-alpine sansW4SeLig" style={{ height: 'auto', 'border': '1px solid #B2E7EE !important' }}>
        <UIGrid
          data={rowData}   // array of row data [{1st row}, {2nd row}]
          properties={colDefArr}  // header and data value
          onblur={handleAfterBlur}
          onchange={onValueChange}
          options={option}
          onclick={handleClick}
        />
        {/* {roStageRows < 9 && <Button
          variant="text"
          size="small"
          onClick={roaddrows}
          className="sansW4SeLig UIGrid_button btn-auto-width"
        >
        + {translateObject('Add New Row')}
        </Button>} */}
      </div>
    </div>
  );
};

export default RoTable;